<template>
  <div id="app">
    <Header @menuChanged="menuChanged"/>
    <transition name="fade">
      <div class="app-container" v-show="showPage">
        <router-view/>
      </div>
    </transition>
    <div class="icon-link">
      <a href="javascript:;" :class="{code: true, show: showCode}" @mouseover="showCode=!showCode" @mouseout="showCode=!showCode" @click="gotoSample">
        <span v-if="showCode">{{language === '1' ? '索取样品' : 'SAMPLE REQUEST'}}</span>
        <i class="ali-icon-icon_edit"/>
      </a>
      <a href="mailto:info@mafco-china.com" :class="{email: true, show: showEmail}" @mouseover="showEmail=!showEmail" @mouseout="showEmail=!showEmail">
        <span v-if="showEmail">info@mafco-china.com</span>
        <i class="iconfont iconxinfeng"/>
      </a>
      <a href="javascript:;" :class="{phone: true, show: showTel}" @mouseover="showTel=!showTel" @mouseout="showTel=!showTel">
        <span v-if="showTel">+86 2152371718、+86 51258325359</span>
        <i class="iconfont icondianhua1"/>
      </a>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'

export default {
  components: {
    Header
  },
  beforeCreate () {
    this.showPage = false
    if (location.href.indexOf('localhost') < 0) {
      let reg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      if (navigator.userAgent.match(reg)) {
        window.location.href = window.location.href.replace('mafco', 'mafco-wap')
        return false
      }
    }
  },
  data () {
    return {
      showEmail: false,
      showTel: false,
      showCode: false,
      showPage: true
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  },
  methods: {
    menuChanged (url) {
      this.showPage = false
      setTimeout(() => {
        this.$router.push(url)
        this.showPage = true
      }, 500)
    },
    gotoSample () {
      if (this.$route.name === 'contactUs') {
        window.location.href = window.location.href + (window.location.hash === '#sample' ? '' : '#sample')
      } else {
        this.$router.push('/contactUs#sample')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/style/base.scss';
.fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
    opacity: 0.3;
}
#app {
  font-family: Microsoft YaHei, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  .app-container {
    margin-top: 0;
  }
  .icon-link {
    position: fixed;
    right: 0;
    bottom: 30px;
    z-index: 99;
    i {
      color: #fff;
      position: absolute;
      right: 10px;
    }
    a:hover {
      background: rgba($color: #000, $alpha: 1);
    }

    .email,
    .phone,
    .code {
      width: 53px;
      height: 56px;
      background: rgba($color: #000, $alpha: .3);
      display: flex;
      justify-content: left;
      align-items: center;
      position: absolute;
      bottom: 30px;
      right: 0;
      text-align: left;
    }

    .email,
    .phone {
      margin-bottom: 1px;
    }
    .code {
      bottom: 145px;
      i {
        padding: 0;
      }
    }
    .phone {
      bottom: 87px;
    }
    .show {
      // width: 250px;
      padding-left: 15px;
      padding-right: 50px;
    }
    .email.show {
      width: 180px;
    }

    a {
      color: #fff;
    }

    i {
      color: #fff;
      font-size: 32px;
    }
    .code.show {
      width: 80px;
      img {
        width: 160px;
        height: 160px;
      }
      i {
        position: absolute;
        bottom: 10px;
      }
    }
    .phone.show {
      width: 300px;
    }
  }
}
</style>
